module.exports = __webpack_public_path__ + "src/img/create.533a4d4d.svg";